angular
  .module('app')
  .controller('PayController', PayController);

PayController.$inject = ['Session', '$stateParams', 'Coupon', 'Config', 'JsVatFactory', 'Films', '$state'];

function PayController(Session, $stateParams, Coupon, Config, JsVatFactory, Films, $state) {
  var vm = this;

  vm.filmid = $stateParams.id;
  vm.filmcat = $stateParams.categoria;
  if (vm.filmcat === 'tourism') {
    vm.bankref = 'T' + vm.filmid;
  } else {
    vm.bankref = 'D' + vm.filmid;
  }

  vm.couponapplied = false;
  vm.euvatapplied = false;
  vm.showtransfer = false;
  vm.showfreebutton = false;
  var config = Config.get().$promise;
  config.then(function (value) {
    if (value.end_offer_date) {
      var endDate = new Date(value.end_offer_date);
      var today = new Date();
      if (today > endDate) {
        vm.value = parseFloat(value.price);
      } else {
        vm.value = parseFloat(value.offer);
      }
    }
    vm.updateTotal();
  });

  vm.vat = 21;
  vm.showvat = false;
  vm.hasvat = function () {
    vm.showvat = !vm.showvat;
  };

  vm.checkEUVat = function () {
    var isVatCorrect = JsVatFactory.checkVAT(vm.euvat);
    if (isVatCorrect.isValid) {
      vm.vat = 0;
      vm.updateTotal();
      vm.euvatapplied = true;
      Session.alert('Yout VAT Number is correct');
    } else {
      Session.alert('Incorrect VAT Number');
    }
  };

  vm.updateTotal = function () {
    vm.vatAmount = vm.value * vm.vat / 100;
    vm.total = vm.value + vm.vatAmount;
    if (vm.total === 0) {
      vm.filmPayment(vm.code);
    }
  };

  vm.checkCoupon = function () {
    if (vm.code) {
      var coupon = Coupon.get({code: vm.code}).$promise;
      coupon.then(function (res) {
        if (res.amount) {
          if (res.type === 'percentage') {
            vm.value -= res.amount * vm.value / 100;
          } else {
            vm.value -= res.amount;
          }
          vm.couponapplied = true;
          vm.updateTotal();
          Session.alert('Coupon successfully applied');
        } else {
          Session.alert('Invalid coupon code');
        }
      });
    }
  };

  vm.paypalopts = {
    createOrder: function (data, actions) {
      // This function sets up the details of the transaction, including the amount and line item details.
      return actions.order.create({
        purchase_units: [{
          amount: {
            value: vm.total
          }
        }]
      });
    },
    onApprove: function (data, actions) {
      // This function captures the funds from the transaction.
      return actions.order.capture().then(function (details) {
        // This function shows a transaction success message to your buyer.
        Session.alert('Transaction completed by ' + details.payer.name.given_name);
        vm.filmPayment('paypal');
      });
    }
  };

  vm.updateTotal();

  vm.filmPayment = function (method) {
    var paymentInfo = {
      amount: vm.value,
      tax: vm.vatAmount,
      couponCode: vm.code,
      paymentMethod: method
    };

    var savepayment = Films.save({id: vm.filmid, cat: vm.filmcat, paymentInfo: paymentInfo}).$promise;
    savepayment.then(function () {
      $state.go('dashboard.newFilm', {
        id: vm.filmid,
        categoria: vm.filmcat
      });
    });
  };
}
